//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import VInput from 'vuetify/lib/components/VInput/VInput'

export default {
  name: 'PhoneVInput',
  extends: VInput,
  props: {
    value: {
      type: [Object, null],
      default: () => {
        return {
          Code: '',
          Number: '',
        }
      },
    },
    maxWidth: {
      type: [Number],
      default: 200,
    },
    formErrors: {
      type: [Object],
      default: undefined,
    },
    setValueNullIfEmpty: {
      type: Boolean,
      default: true,
    },
  },
  data() {
    return {
      phoneValidation: undefined,
      msg: '',
      code: '',
      number: '',
    }
  },
  computed: {
    hasError() {
      return !this.phoneValidation
    },
  },
  watch: {
    value: {
      handler(val) {
        this.code = val?.Code || ''
        this.number = val?.Number || ''
        if (
          this.setValueNullIfEmpty &&
          val !== null &&
          !(this.code + this.number).length
        ) {
          this.$emit('input', null)
        }
      },
      deep: true,
      immediate: true,
    },
    formErrors: {
      handler() {
        this.$nextTick(() => {
          this.errorMsg()
        })
      },
      deep: true,
    },
  },
  methods: {
    requiredWith(val) {
      return (
        !!val === !!(this.code + this.number).length ||
        this.$t('validation_new.required')
      )
    },
    errorMsg() {
      this.msg =
        (this.$refs?.code?.validations || [])[0] ||
        (this.$refs?.number?.validations || [])[0] ||
        ''
    },
    onInput() {
      this.$emit(
        'input',
        this.setValueNullIfEmpty && !!(this.code + this.number).length
          ? { Code: this.code, Number: this.number }
          : null
      )
    },
    validate() {
      this.valid = this.$refs?.form?.validate()
      this.errorMsg()
      return this.valid
    },
    reset() {
      this.isResetting = true
      this.valid = true
      this.$refs?.form?.reset()
      this.errorMsg()
    },
    resetValidation() {
      this.isResetting = true
      this.valid = true
      this.$refs?.form?.resetValidation()
      this.errorMsg()
    },
  },
}
